module.exports = __webpack_public_path__ + "static/media/load.44271f65.gif";